import { Component, computed, input } from "@angular/core";
import { PageMeta } from "@models/page";

@Component({
    selector: "app-paginator-report",
    imports: [],
    template: `
    @if (!hasMeta()) {
      <span aria-live="polite">Carregando lista...</span>
    } @else {
      <span aria-live="polite">{{ report() }}</span>
    }
  `,
    styleUrl: "./paginator-report.component.scss"
})
export class PaginatorReportComponent {
  meta = input<PageMeta | null | undefined>(undefined);

  template = input<string>(
    "Exibindo {first}–{last} de {totalRecords} resultados (página {currentPage} de {totalPages})",
  );

  hasMeta = computed(() => !!this.meta());

  private hasPageSize = computed(
    () => !!this.meta()?.page_size && (this.meta()!.page_size as number) > 0,
  );
  private pageSize = computed(() => this.meta()?.page_size ?? 0);
  private current = computed(() => Math.max(1, this.meta()?.current_page ?? 1));
  private total = computed(() => Math.max(0, this.meta()?.total_count ?? 0));
  private totalPages = computed(() =>
    Math.max(1, this.meta()?.total_pages ?? 1),
  );

  private first = computed<number | null>(() => {
    if (!this.hasMeta() || !this.hasPageSize()) return null;
    const size = this.pageSize();
    return (this.current() - 1) * size + 1;
  });

  private last = computed<number | null>(() => {
    if (!this.hasMeta() || !this.hasPageSize()) return null;
    const f = this.first()!;
    const size = this.pageSize();
    return Math.min(f + size - 1, this.total());
  });

  report = computed(() => {
    // Se não houver meta ainda (fallback de segurança)
    if (!this.hasMeta()) return "Carregando lista...";

    const tpl = this.template();
    const ctx = {
      first: this.first(),
      last: this.last(),
      totalRecords: this.total(),
      currentPage: this.current(),
      totalPages: this.totalPages(),
    };

    let normalized = tpl;
    if (ctx.first == null || ctx.last == null) {
      normalized = this.stripRange(normalized);
    }

    return normalized
      .replaceAll("{first}", ctx.first?.toString() ?? "")
      .replaceAll("{last}", ctx.last?.toString() ?? "")
      .replaceAll("{totalRecords}", ctx.totalRecords.toString())
      .replaceAll("{currentPage}", ctx.currentPage.toString())
      .replaceAll("{totalPages}", ctx.totalPages.toString())
      .replace(/\s{2,}/g, " ")
      .replace(/ \)/g, ")")
      .trim();
  });

  /** Remove o segmento que contenha {first} e {last} (ex.: "Mostrando {first}-{last} de ") */
  private stripRange(tpl: string): string {
    const re = /[^{}]*\{first\}[^{}]*\{last\}[^{}]*/g;
    return tpl.replace(re, "");
  }
}
